// TODO: Utiliser la méthode genericFetch<T> dans toutes les fonctions.

import { genericFetch } from "./common-service"
import { apiBaseUrl } from "./config"
import { createServiceRequestBody } from "./factory"
import { ServiceRequestBody } from "./request-body"
import { getBaseHeader } from "./utils"
import ApiError, { ApiErrorCode } from "../../error/api-error"
import * as Model from "../../model"

const serviceNotFoundError = new ApiError(ApiErrorCode.NotFound, "Le service n'existe pas.")
const unexpectedError      = new Error("Unexpected error.")

const SERVICES          = "services"
const LOCAL_AUTHORITIES = "localauthorities"
const CHILDREN = 'children'

export function createService(
	localAuthority: Model.LocalAuthority,
	label: string,
	code: string,
	group: number,
	description?: string,
	approaches?:any
): Promise<Model.Service> {
	const url: string = `${apiBaseUrl}/${LOCAL_AUTHORITIES}/${localAuthority.id}/${SERVICES}`
	const service: ServiceRequestBody = createServiceRequestBody(label, code, group, description,approaches)
	const init: RequestInit = {
		body: JSON.stringify(service),
		headers: {
			...getBaseHeader(),
			"Content-Type": "application/json"
		},
		method: "POST"
	}

	return fetch(url, init)
	.then(response => {
		switch (response.status) {
			case 200:
				return response.json().then(value => value as Model.Service)
			case 401:
				throw new ApiError(ApiErrorCode.Unauthorized, "Vous n'êtes pas autorisé à créer de gestionnaire pour cette collectivité.")
			case 404:
				throw serviceNotFoundError
		}
		throw unexpectedError
	})
}

export function deleteService(
	service: Model.Service
): Promise<void> {
	const url = `${apiBaseUrl}/${LOCAL_AUTHORITIES}/${service.localAuthority}/${SERVICES}/${service.slug}`
	const init: RequestInit = {
		headers: getBaseHeader(),
		method: "DELETE"
	}
	return genericFetch<void>(url, init)
}

export function findAgents(service: Model.Service, signal: AbortSignal): Promise<Model.User[]> {
	const url = `${apiBaseUrl}/${LOCAL_AUTHORITIES}/${service.localAuthority}/${SERVICES}/${service.id}/agents`
	const headers: HeadersInit = {
		...getBaseHeader(),
		"Content-Type": "application/json"
	}
	const init: RequestInit = { headers, signal }
	return genericFetch<Model.User[]>(url, init)
}

export function findServices(localAuthority: Model.LocalAuthority): Promise<Model.Service[]> {
	const url = `${apiBaseUrl}/${LOCAL_AUTHORITIES}/${localAuthority.id}/${SERVICES}`
	const init: RequestInit = { headers: getBaseHeader() }

	return genericFetch<Model.Service[]>(url, init)
}

export function findServicesComingGroup(id:Number): Promise<Model.Service[]> {
	const url = `${apiBaseUrl}/${LOCAL_AUTHORITIES}/${id}/${SERVICES}`
	const init: RequestInit = { headers: getBaseHeader() }

	return genericFetch<Model.Service[]>(url, init)
}



export function findAllLocalAuthoritiesChildren(slug:any): Promise<Model.LocalAuthority[]> {
	const url = `${apiBaseUrl}/${LOCAL_AUTHORITIES}/${slug}/${CHILDREN}`
	const init: RequestInit = { headers: getBaseHeader() }

	return genericFetch<Model.LocalAuthority[]>(url, init)
}

export function findUserChild(
	user: Model.User,
	signal: AbortSignal
): Promise<Model.LocalAuthority[]> {
	const url = `${apiBaseUrl}/${LOCAL_AUTHORITIES}/${user.relatedLocalAuthoritySlug}/${CHILDREN}`
	const init: RequestInit = {
		headers: {
			...getBaseHeader(),
			"Content-Type": "application/json"
		},
		signal
	}

	return genericFetch<Model.LocalAuthority[]>(url, init)
}



export function findOneService(localAuthority: Model.LocalAuthority, slug: string): Promise<Model.Service> {
	const url : string      = `${apiBaseUrl}/${LOCAL_AUTHORITIES}/${localAuthority.id}/${SERVICES}/${slug}`
	const init: RequestInit = { headers: getBaseHeader() }

	return fetch(url, init)
	.then(response => {
		switch (response.status) {
			case 200:
				return response.json().then(value => value as Model.Service)
			case 401:
				throw new ApiError(ApiErrorCode.Unauthorized, "Vous n'êtes pas autorisé à voir ce gestionnaire de cette collectivité.")
			case 404:
				throw serviceNotFoundError
		}
		throw unexpectedError
	})
}

export function updateService(
	service: Model.Service,
	signal?: AbortSignal
): Promise<Model.Service> {
	const url = `${apiBaseUrl}/${LOCAL_AUTHORITIES}/${service.localAuthority}/${SERVICES}/${service.slug}`
	const body = JSON.stringify({ service })
	const init: RequestInit = {
		body,
		headers: {
			...getBaseHeader(),
			"Content-Type": "application/json"
		},
		method: "PUT",
		signal
	}
	return genericFetch<Model.Service>(url, init)
}



// WEBPACK FOOTER //
// ./src/service/sfp/services-service.ts